import { OutgoingGetInvoiceListProps } from '../../../types/Invoicing/Invoices/InvoiceListTypes'

export const outgoingInitialGetInvoiceListProperties: OutgoingGetInvoiceListProps =
  {
    status: [],
  }
export const filterOptionStatusInfo: string[] = [
  'RAISED',
  'SENT',
  'OVER DUE',
  'PARTIALLY RECEIVED',
  'RECEIVED',
  'NOT SENT',
  'WRITE OFF',
]
export const getIndexOfInvoicesFromList = (
  list: string[],
  value: string,
): null | number => {
  const indexVal = list.findIndex((ratingVal) => ratingVal === value)
  return indexVal === -1 ? null : indexVal
}
export const getStatusListTestingId = (value: string): string => {
  return `statuslist-${value}`
}
